import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Content from "@/components/POD/Content";
import Header from "@/components/POD/Header";
const PODPage = ()=>{
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Header, {}),
            /*#__PURE__*/ _jsx(Content, {})
        ]
    });
};
export default PODPage;
